// extracted by mini-css-extract-plugin
export default {"image":"G2-z","loaded":"H2-z"};